import { CompactAllocation } from "../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown, faDatabase } from "@fortawesome/free-solid-svg-icons";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useModal } from "@hooks/useModal";
import FormDataPreview from "../../Formular/FormDataPreview";
import AttendanceBookerToggle from "../Attendance/AttendanceBookerToggle";
import BookerStatusBadge from "../BookerStatusBadge";

interface Props {
    allocation: CompactAllocation;
}

// Booker column of the allocation list — names, form data and status per participant.
const Bookers = ({ allocation }: Props) => {
    const [setModal] = useModal();
    const { t } = useTranslation("space-manager");

    // opens the submitted booking form of a single booker
    const handleShowFormDataPreview = useCallback((formDataId: number) => {
        setModal({
            title: t("allocationList.formDataModalTitle"),
            content: <FormDataPreview formDataId={formDataId} />,
            show: true
        });
    }, [t]);

    return allocation.bookers?.length > 0 ? <div className="tw-card-flat tw-p-2 tw-px-4 tw-my-2">
        {allocation.bookers?.map((booker, index) => <div key={booker.id}
            className="tw-flex tw-items-start tw-border-solid tw-border-0 tw-border-b last:tw-border-b-0 tw-py-1 tw-justify-between tw-border-b-accents-3 tw-z-0"
        >
            <div className="tw-flex tw-flex-col">
                <span className="tw-text-sm tw-text-accents-8 tw-flex tw-items-baseline tw-gap-4">
                    {index === 0 && <FontAwesomeIcon size="xs" icon={faCrown} />}
                    <span>{booker.user_name}</span>

                </span>
                <span className="tw-text-xs tw-italic tw-text-accents-5">{booker.user_email}</span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-2 tw-min-h-[24px] tw-text-accents-6">
                {booker.form_data_id &&
                    <button className="tw-border-none tw-bg-transparent tw-text-accents-6"
                        onClick={() => handleShowFormDataPreview(booker.form_data_id)}
                    ><FontAwesomeIcon icon={faDatabase} /></button>}
                {/* read-only here — the per-booker confirmation lives in the grid preview,
                    the list confirms the whole booking via its row action */}
                {!!allocation.attendance && <AttendanceBookerToggle booker={booker} />}
                <BookerStatusBadge booker={booker} />
            </div>
        </div>)}
    </div> : null;
};

export default Bookers;